import React, { useEffect, useState, useContext } from "react";
import Module from "../../../../templates/components/Module";
import moment from "moment";
import Utilities from "../../../../../services/commonservice/utilities";
import Table2 from "../../../../templates/components/Table2";
import HPTDatePicker from "../../../../templates/components/HPTDatePicker";
import DimLoader from "../../../../templates/components/DimLoader";
import { store } from "../../../../../context/StateProvider";
import InvoiceService from "../../../../../services/api/invoice.service";
import PatientSelector from "../../../../templates/components/PatientSelector";
import HPTSelect from "../../../../templates/components/HPTSelect";
import { useGetLocationProviderServices } from "../../../../../services/cache/CacheService";
import CacheUtilities from "../../../../../services/cache/CacheUtilities";

const InvoiceItemsTable = (props) => {
  // context state and dispatch 
  const globalStateAndDispatch = useContext(store)
  const state = globalStateAndDispatch.state
  const [invoiceItemsList, setInvoiceItemsList] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("D"));
  const [endDate, setEndDate] = useState(moment().endOf("D"));
  const [initialMessage, setInitialMessage] = useState(true)
  const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
  const [locationId, setLocationId] = useState(state.practiceLocationId || null)
  const [patientId, setPatientId] = useState()
  const [doctorId, setDoctorId] = useState()
  const [providerList, setProviderList] = useState()
  const stateDoctorList = useGetLocationProviderServices();
  const [selectedGroups, setSelectedGroups] = useState([]);
  useEffect(async () => {
    if (locationId) {
      if (locationId == state.practiceLocationId) {
        setProviderList(stateDoctorList)
      }
      else {
        const locProviderServices = await CacheUtilities.pullServiceForLocationData(locationId);
        setProviderList(locProviderServices)
      }
    } else {
      const locProviderServices = await CacheUtilities.pullServiceForLocationData(null);
      setProviderList(locProviderServices)
    }
    setDoctorId()
  }, [locationId, stateDoctorList]);

  const onPatientChange = (newPatientId) => {
    setPatientId(newPatientId)
  }
  const invoiceItemsLookup = () => {
    let reqObj = {};
    if (locationId) {
      reqObj.PracticeLocationId = locationId
    }
    if (startDate) reqObj.StartDate = moment(startDate).toISOString()
    if (endDate) reqObj.EndDate = moment(endDate).toISOString()
    if (patientId) {
      reqObj.PatientId = patientId
    }
    if (doctorId) {
      reqObj.DoctorId = doctorId
    }
    setIsLoader(true)
    setInitialMessage(false);
    InvoiceService.getInvoiceItemsReport(reqObj)
      .then((res) => {
        //console.log(JSON.stringify(res))
        if (res?.data?.data) {
          setInvoiceItemsList(res?.data?.data);
          setIsLoader(false);
        } else {
          setInvoiceItemsList();
          setIsLoader(false);
        }
      })
      .catch((err) => console.log(err));
  };
  const getFilteredInvoiceItems = () => {
    if (!selectedGroups || selectedGroups.length === 0) {
      return invoiceItemsList;
    }
    return invoiceItemsList?.filter(obj => selectedGroups.includes(obj.reportGroup));
  };
  const getExtraElements = () => {
    if (!invoiceItemsList || invoiceItemsList.length === 0) {
      return null; // Hide the extraElements if there's no data
    }
    const uniqueReportGroups = Array.from(
      new Set(invoiceItemsList.map(item => item.reportGroup))
    ).filter(Boolean);

    if (uniqueReportGroups.length === 0) {
      return null; // hide if no valid report groups
    }

    const options = uniqueReportGroups.map(item => ({
      key: item,
      value: item,
      text: item
    }));

    return [
      {
        children: (
          <div className="col-md-auto" style={{ minWidth: '200px' }}>
            <label>Report Group</label>
            <HPTSelect
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="All"
              options={options}
              onChange={(selectedOptions) => {
                const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                setSelectedGroups(values);
              }}
              isMulti
              isSearchable
              isClearable
              getOptionLabel={(option) => option.key}
              getOptionValue={(option) => option.value}
            />
          </div>
        ),
      },
    ];
  };

  const columns = [
    {
      id: "reportGroup",
      Header: "Report Group",
      accessor: (tc) => tc.reportGroup,
    },
    {
      id: "invoiceNumber",
      Header: "Invoice Number",
      accessor: (tc) => tc.invoiceNumber,
      minWidth: "150px"
    },
    {
      id: "invoiceDate",
      Header: "Invoice Date",
      accessor: (pp) => {
        return pp.invoiceDate ? moment.utc(pp.invoiceDate).format("MM/DD/YYYY") : ''
      },
    },
    {
      id: "practiceLocation",
      Header: "Practice Location",
      accessor: (pp) => pp.practiceLocation,
    },
    {
      id: "patientName",
      Header: "Patient",
      accessor: (pp) => pp.patientName,
    },
    {
      id: "invoiceType",
      Header: "Invoice Type",
      accessor: (tc) => tc.invoiceType,
    },
    {
      id: "invoiceStatus",
      Header: "Invoice Status",
      accessor: (tc) => tc.invoiceStatus,
    },
    {
      id: "productOrService",
      Header: "Product/Service",
      accessor: (tc) => tc.productOrService,
      minWidth: "150px"
    },
    {
      id: "isProcedural",
      Header: "Procedural",
      accessor: (tc) => tc.isProcedural ? 'Yes' : '',
    },
    {
      id: "itemType",
      Header: "Item Type",
      accessor: (tc) => tc.itemType,
    },
    {
      id: "membershipItemRedeemed",
      Header: "Membership Item Redeemed",
      accessor: (tc) => tc.membershipItemRedeemed,
    },
    {
      id: "cashValueApplied",
      Header: "Cash Value Applied",
      accessor: (tc) => tc.cashValueApplied,
    },
    {
      id: "unitPrice",
      Header: "Unit Price",
      accessor: (pp) => { return Utilities.toDollar(pp.unitPrice) },
    },

    {
      id: "quantity",
      Header: "Quantity",
      accessor: (pp) => pp.quantity,
    },
    {
      id: "lineSubTotal",
      Header: "SubTotal",
      meta: { sum: true, currency: true, numeric: true },
      accessor: (pp) => { return Utilities.toDollar(pp.lineSubTotal) },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.lineSubTotal + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },

    {
      id: "calculatedDiscountAmount",
      Header: "Discount",
      meta: { sum: true, currency: true, numeric: true },
      accessor: (pp) => { return Utilities.toDollar(pp.calculatedDiscountAmount) },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.calculatedDiscountAmount + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },
    {
      id: "lineTaxAmount",
      Header: "Tax",
      meta: { sum: true, currency: true, numeric: true },
      accessor: (pp) => { return Utilities.toDollar(pp.lineTaxAmount) },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.lineTaxAmount + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },

    {
      id: "lineTotal",
      Header: "Total",
      meta: { sum: true, currency: true, numeric: true },
      accessor: (pp) => { return Utilities.toDollar(pp.lineTotal) },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.lineTotal + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },
  ]

  return (
    <>
      {isLoader &&
        <DimLoader loadMessage="Processing" />
      }
      <div className="row d-flex g-3">
        <div className="col-12 m-p-0">
          <Module title="Filters">
            <div className='row d-flex'>
              <div className='col-12 mx-0  report-filters'>
                <div className="d-flex row justify-content-center align-items-end">
                  <HPTDatePicker locationClearable={isLocationClearable} setLocationId={setLocationId} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} includeAll />
                  <div className='col-md col-12'>
                    <div className='ui field'>
                      <label>Patient</label>
                      <PatientSelector onSelected={onPatientChange} showAddPatient={false} />
                    </div>
                  </div>
                  <div className='col-md col-12'>
                    <div className='ui field'>
                      <label>Provider</label>
                      <HPTSelect
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={providerList}
                        name="doctorId"
                        isDisabled={!providerList}
                        isClearable={true}
                        isSearchable
                        value={providerList && doctorId ? providerList.find(obj => obj.id === doctorId) : null}
                        onChange={e => {
                          if (e?.id) {
                            setDoctorId(e.id)
                          }
                          else {
                            setDoctorId()
                          }
                        }}
                        loadingMessage="Providers are loading..."
                        getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                        getOptionValue={(option) => option.id}
                      />
                    </div>
                  </div>
                  <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault(); setInvoiceItemsList();setSelectedGroups([]); invoiceItemsLookup() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>
                </div>
              </div>
            </div>
          </Module>
        </div>
        <div className="col-12 m-p-0">
          <Module title="Invoice Items">
            <Table2
              export
              searchable
              title="Invoice Items"
              data={getFilteredInvoiceItems()}
              loading={isLoader}
              columns={columns}
              initialMessage={initialMessage}
              extraElements={getExtraElements()}
            />
          </Module>
        </div>
      </div>
    </>
  );
};

export default InvoiceItemsTable;
